import { useRef } from "react";
import {
  motion,
  useScroll,
  useTransform,
  useMotionTemplate
} from "framer-motion";


const ContentLine = ({ content }) => {
  const contentRef = useRef();

  const { scrollYProgress } = useScroll({
    target: contentRef,
    offset: ["end center", "start start"]
  });

  const scrollValue = useTransform(scrollYProgress, [0, 0.15], ["100%", "0%"]);
  const clipPathVal = useMotionTemplate`inset(0% ${scrollValue} 0% 0%)`;

  return (
    <span className="text-container" ref={contentRef}>
      <motion.span
        style={{ clipPath: clipPathVal }}
        className="highlighted-text"
        data-text={content}
      />
      <span className="static-text">{content}</span>
    </span>
  );
};

 const ScrollText = ({ content }) => {
  return (

      <div className="inner">
        <h3>
          {content?.map((item) => (
            <ContentLine key={item} content={item} />
          ))}
        </h3>
      </div>

  );
};

export default ScrollText;
